import Component from '@bythepixel/component-loader';

export default class Dialog extends Component {
  static selector = '[data-comp-dialog]';
  static closeSelector = '[data-comp-close-trigger]';

  constructor(containerEl, options) {
    super(containerEl, options);

    if (this.$container.hasAttribute('data-comp-dialog-opened')) {
      this.$container.showModal();
    }

    const closeButton = this.$container.querySelector(Dialog.closeSelector);
    closeButton.addEventListener('click', () => {
      this.$container.close();
    });
  }
}
